import React from "react";

/**
 * ArrowDown icon component
 * @component
 * @param {Object} props - Component props
 * @param {string} [props.color="#4C70EF"] - Color of the arrow icon
 * @param {number} [props.width=16] - Width of the icon in pixels
 * @param {number} [props.height=16] - Height of the icon in pixels
 * @returns {JSX.Element} ArrowDown icon component
 */
const ArrowDown = ({ color = "#4C70EF", width = 16, height = 16 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 3.33334V12.6667M8 12.6667L12.6667 8M8 12.6667L3.33333 8"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowDown; 